import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=3a31a4c2"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=3a31a4c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports